import moment from "moment";
import imageCompression from 'browser-image-compression';

export const compareDates = (date1, date2) => {
    const d1 = new Date(date1);
    const d2 = new Date(date2);
    console.log(d1,d2)
  
    if (d1 < d2) return -1; // date1 is less than date2
    if (d1 > d2) return 1;  // date1 is greater than date2
    return 0; // date1 is equal to date2
  };

   // utc
 export function dateLabel(inputDateStr) {
  const inputDate = new Date(inputDateStr);
  const today = new Date();

  // Normalize both dates to remove time part
  inputDate.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  if (inputDate.getTime() < today.getTime()) {
    return "past";
  } else if (inputDate.getTime() >= today.getTime()) {
    return "future";
  } 
  // else {
  //   return "today";
  // } 
}
  

  // string input
  export const formatStrToDate=(date)=>{
    return  moment(date).format("MMM Do YYYY")
  }

  export const formatStrToDateWithTime=(date)=>{
    return  moment(date).format("MMM Do YYYY, h:mm a")
  }

  export function formatIndianCurrency(numValue){
   return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      nimumFractionDigits: 0,
    maximumFractionDigits: 0,  
    }).format(numValue || 0);
  }

  export  function consoleLogProduction(...arg){
    if (process.env.NODE_ENV != "production") {
      return console.log(...arg)
    }

  }

  export function capitalizeWords(input) {
    return input.replace(/\b\w/g, (char) => char.toUpperCase());
}

export function getMonth(val){
  const shortMonths = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return shortMonths[val]
}

export const compressImage = async (imageFile) => {
  if(!imageFile) return 
  
  const options = {
    maxSizeMB: 1,          // Maximum file size in MB
    maxWidthOrHeight: 1920, // Maximum width or height
    useWebWorker: true,    // Use web worker for faster compression
  };

  try {
    const compressedFile = await imageCompression(imageFile, options);
    return compressedFile;
  } catch (error) {
    // console.error('Image compression error:', error);
    // throw error;
  }
};

export const getFormDataSize = (formData) => {
  let totalBytes = 0;
  
  // Loop through all entries in the FormData object
  for (const [key, value] of formData.entries()) {
    if (value instanceof File) {
      totalBytes += value.size;
    } else if (typeof value === 'string') {
      totalBytes += new TextEncoder().encode(value).length;
    } else if (value instanceof Blob) {
      totalBytes += value.size;
    }
  }
  
  return totalBytes;
};

// MARK: Flight utils
export const listingFareShow = (fare) => {
  return fare?.adultFare + fare?.adultTax 
} 

// MARK: Flight utils
export const returnFareForFareList = (fares) => {
  const fareRes = Array.isArray(fares) ? fares[0] : fares; 
  return fareRes
} 

// MARK: API UTILs
export const errorHandlerAxios = function (error) {
  
  console.log("GOT ERROR",error)
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.log("SERVER ERROR")
      console.log(error.response.data);
      console.log(error.response.status);
      console.log(error.response.headers);
      return error.response
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log("CLIENT ERROR")
      console.log(error.request);
       return error.request
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log('Something happened in setting up the request that triggered an Error Error', error.message);
    }
    console.log(error.config);
    return error.config

  }


  // MARK: Insurance Utils
  export function getAddonPriceList(insuranceData){
    const keyName = {
      blueRibbon : "Baggage Insurance Blue Ribbion",
      insurance : "Insurance"
    }
    if(!insuranceData) return []
    
    const addedAmounts = Object.entries(insuranceData)
      .filter(([_, value]) => value?.addedAmount !== undefined)
      .map(([key, value]) => ({ key : keyName[key], addedAmount: value.addedAmount }));
    return addedAmounts
}

